import {SidebarHeader} from '@/components/ui/sidebar-atoms/SidebarAtoms'
import styled, {css} from 'styled-components'

export const StyledSidebarContainer = styled.div(
    ({theme: {spacing}}) => css`
        padding: 0 ${spacing * 4}px;
    `
)
export const StyledAccountModalSidebarHeader = styled(SidebarHeader)(
    ({theme: {typography, spacing, palette}}) => css`
        padding: ${spacing * 4}px ${spacing * 5}px;
        color: ${palette.neutral.black};
        height: 60px;
        & > h2 {
            ${typography.textXl}
        }
    `
)
